export default "__VITE_ASSET__CWXFgAeJ__"